export const ProductAttributePathSettings = {
    "Title": {
        "label": "Title",
        "description": "The title of the product.",
        "dataType": "String",
        "optional": false,
        "group": "Main",
        defaultFilter: {
            "fieldPath": "Title",
            "comparison": "EqualTo",
            "value": null,
        }
    },
    "Vendor": {
        "label": "Vendor",
        "description": "The name of the product's vendor.",
        "dataType": "String",
        "optional": false,
        "group": "Main",
        defaultFilter: {
            "fieldPath": "Vendor",
            "comparison": "EqualTo",
            "value": null,
        }
    },
}

export const DataTypeFieldFilterSettings = {
    "String": {
        "EqualTo": { label: 'is equal to', filterType: "StringFieldFilter" },
        "NotEqualTo": { label: 'is not equal to', filterType: "StringFieldFilter" },
        "Contains": { label: 'contains', filterType: "StringFieldFilter" },
        "DoesNotContain": { label: 'does not contain', filterType: "StringFieldFilter" },
        "StartsWith": { label: 'starts with', filterType: "StringFieldFilter" },
        "DoesNotStartWith": { label: 'does not start with', filterType: "StringFieldFilter" },
        "EndsWith": { label: 'ends with', filterType: "StringFieldFilter" },
        "DoesNotEndWith": { label: 'does not end with', filterType: "StringFieldFilter" },
    },
};

export const FieldFilterTypeSettings = {
    "StringFieldFilter": {
        valueTypes: ["Single", "Multiple"],
        body: {
            "filterType": "StringFieldFilter",
            "fieldPath": null,
            "comparison": "EqualTo",
            "value": null,
        }
    },
};

export const OptionalDataTypeFilterSettings =
{
    "HasValue": { label: 'has value', conditionType: "HasValue" },
    "HasNoValue": { label: 'has no value', conditionType: "HasValue" },
};

export function conditionTypeSettingsToSelectOptions(attributeType, isOptional) {
    var settings = DataTypeFieldFilterSettings[attributeType];
    var typeOptions = Object.keys(settings).map(_ => {
        return {
            label: settings[_].label,
            value: _,
        }
    });

    var optionalTypeOptions = [];

    if (isOptional) {
        var optionalTypeSettings = OptionalDataTypeFilterSettings;
        optionalTypeOptions = Object.keys(optionalTypeSettings).map(_ => {
            return {
                label: optionalTypeSettings[_].label,
                value: _,
            }
        });
    }

    return [
        ...typeOptions,
        ...optionalTypeOptions
    ];
}